import React, {} from "react";
import { useQuery, gql } from "@apollo/client";
import insights6 from '../../media/images/insights6.png';

const PRODUCTS_QUERY = gql`
  {
    products {
      title
      slug
      coverImage {
        url
      }
      content {
        text
      }
      url
    }
  }
`;

const truncate = (text, max = 240) =>
  !text ? "" : text.length > max ? text.slice(0, max).trim() + " …" : text;

export default function GetProducts({ isTablet, isMobile }) {
  const { loading, error, data } = useQuery(PRODUCTS_QUERY);

  if (loading) return null;
  if (error || !data || !data.products || data.products.length === 0)
    return null;

  return (
    <div className="section">
      <div className="row">
        {data.products.map((p, idx) => {
          const title = p && p.title ? p.title : "Produkt";
          const link = p && p.url ? p.url: "";
          const img =
            p && p.coverImage && p.coverImage.url ? p.coverImage.url : null;
          const revealText =
            p && p.slug && p.slug
              ? p.slug
              : "Weitere Informationen finden Sie auf der Produktseite.";

          return (
            <div
              key={p && p.slug ? p.slug : idx}
              className={"col s12 " + (isTablet || isMobile ? "m12" : "m4")}
            >
              <div className="card">
                <div className="card-image">
                  {img ? (
                    <img
                      className="activator"
                      src={img}
                      alt={title}
                      loading="lazy"
                    />
                  ) : (
                    <img
                      className="activator"
                      src={insights6}
                      alt={title}
                      loading="lazy"
                    />
                  )}
                </div>

                <div className="card-content">
                  <span className="card-title activator grey-text text-darken-4">
                    {title}
                    <i className="material-icons right">more_vert</i>
                  </span>
                  <a
                    className="orange-text text-darken-4"
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Mehr erfahren
                  </a>
                </div>

                <div className="card-reveal">
                  <span className="card-title grey-text text-darken-4">
                    {title}
                    <i className="material-icons right">close</i>
                  </span>
                  <p className="light">
                    {truncate(revealText, 320)}{" "}
                    <a
                      className="orange-text text-darken-4"
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      mehr erfahren
                    </a>{" "}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/services/applications.js